import { IAssetResolver } from './asset-resolver.interface';

export abstract class AssetResolverBase implements IAssetResolver {
    public abstract resolve(file: string): string;
}
